import React from 'react';

import "./QuestionList.css";

const QuestionListFreeForm = ({clsHidden, draftActiveProject, questionIndex, handleQuestionInputChange}) => {
  return (
    <div className={`form-question-section ${clsHidden}`}>
      <div className="form-row">
        <div className="form-group col-12">
          <label className="form-label" htmlFor="js-form-free-form-question">Question</label>

          <input
            type="text"
            className="form-control form-input"
            id="js-form-free-form-question"
            placeholder="e.g: What do you like most about DevNet?"
            name="description"
            value={draftActiveProject.questions[questionIndex].description}
            onChange={handleQuestionInputChange(questionIndex)}
          >
          </input>
        </div>
      </div>
    </div>
  )
}

export default QuestionListFreeForm;
